/** @format */

import { toRegexp, toPath } from "@riotjs/route";
import indexPage from "@tags/pages/register/index.riot";
import hasClientId from "@tags/pages/register/has-client-id.riot";
import agreement from "@tags/pages/register/agreement.riot";
import complete from "@tags/pages/register/complete.riot";

const pages = [
  {
    path: "/register",
    is: "index-tag",
    component: indexPage,
  },
  {
    path: "/register/has-client-id",
    is: "has-client-id-tag",
    component: hasClientId,
  },
  {
    path: "/register/agreement",
    is: "agreement-tag",
    component: agreement,
  },
  {
    path: "/register/complete",
    is: "complete-tag",
    component: complete,
  },
];

for (const page of pages) {
  page.route = toRegexp(page.path, [], { endsWith: "([#?].*)?" });
}

const routes = {
  pages,
  makePath: (name, param) =>
    toPath(pages.find((v) => v.is == name).path, param),
};

export default routes;
